import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { HelperService } from 'src/app/core/services/helper.service';
import { opacityInOut } from 'src/app/shared/animations/opacity-in-out.animation';
import { scaleInOut } from 'src/app/shared/animations/scale-in-out.animation';
import { slideInOut } from '../../animations/slide-in-out.animation';

@Component({
  selector: 'notify-popup',
  templateUrl: 'notify-popup.component.html',
  styleUrls: ['notify-popup.component.scss'],
  animations: [ opacityInOut, scaleInOut, slideInOut ]
})
export class NotifyPopupComponent implements OnInit, OnDestroy {

  @Input() set show(val) {
    this.showPopup = val;
  };
  @Input() isSetOrUpdateJobPositionOnVacancy = false;
  @Input() title = null;
  @Input() msg = null;
  @Input() isFinish = false;
  @Input() cancelLabel = 'Back';
  @Input() okLabel = 'Next';
  @Input() resultTitle = null;
  @Input() resultMsg = null;
  @Input() hasTextarea = null;
  @Input() checkboxLabel = 'Do not show this dialog again.';
  @Input() checkboxStorageKey = null;
  @Input() checkboxOnClose = false;
  @Input() isLoading = false;
  @Output() onChanged = new EventEmitter<boolean | { msg: any }>();
  control = new FormControl(null,  [ Validators.required, Validators.minLength(10), Validators.maxLength(450) ]);
  isSubmitted = false;
  showPopup = false;
  showResult = false;
  checkboxResult = false;

  constructor(private helperService: HelperService) {
  }

  ngOnInit(): void {
    this.helperService.blockScroll$.next(true);
  }

  close() {
    if (this.helperService.isBrowser() && this.checkboxOnClose && this.checkboxStorageKey && this.checkboxResult) {
      localStorage.setItem(this.checkboxStorageKey, 'true');
    }
    this.onChanged.emit(null);
  }

  cancel() {
    if (this.helperService.isBrowser() && this.checkboxOnClose && this.checkboxStorageKey && this.checkboxResult) {
      localStorage.setItem(this.checkboxStorageKey, 'true');
    }
    this.onChanged.emit(false);
  }

  proceed() {
    if (this.helperService.isBrowser() && this.checkboxStorageKey && this.checkboxResult) {
      localStorage.setItem(this.checkboxStorageKey, 'true');
    }
    if (this.hasTextarea) {
      if (this.control.value) {
        if (this.control.valid) {
          this.onChanged.emit({ msg: this.control.value });
          this.showResult = true;
        } else {
          this.isSubmitted = true;
        }
      }
    } else if (this.resultTitle || this.resultMsg) {
      this.showResult = true;
      this.onChanged.emit(true);
    } else {
      this.onChanged.emit(true);
    }
  }

  checkboxChange(e) {
    this.checkboxResult = e;
  }

  ngOnDestroy(): void {
    this.helperService.blockScroll$.next(false);
  }

}
